export const TIME_RESTRICTION = 3599; //59:59
